import { load } from 'cheerio';

export function extractERSProductPaths(htmlSource: string): string[] {
    const $ = load(htmlSource);
    const productPathsSet = new Set<string>();

    $('.ers-item-container a[href^="/items/"], .col-md-4 a[href^="/items/"]').each((_, anchor) => {
        const href = $(anchor).attr('href');
        if (href) {
            productPathsSet.add(href);
        }
    });

    return Array.from(productPathsSet);
}
